import { useEffect, useState } from "react"
import ReactJson from "@microlink/react-json-view"
import { Link } from "react-router-dom"
import { TeamDataTree } from "./Team"
import { TypeSelector } from "./Template"
import { Button, Modal } from "react-bootstrap"
import { TimeStringForTimeZone } from "./Setting"
import useAuth from "../hook/useAuth"
import useDeepVinApi from "../hook/useDeepvinApi"

const accountTypes = ['Demo', 'Test', 'Distributor', 'Customer']
const trialDays = [15, 30, 60, 90]

export const Accounts= () =>  {
  //const accounts = DataProvider(dvSrv + `/api/account/`)
  // const { setAuth } = useAuth()
  const api = useDeepVinApi()
  const [accounts, setAccounts] = useState([]) 
  const [showAccountModal, setShowAccountModal] = useState(false)

  const [flag, setFlag] = useState(false)
  const refresh = () => {
    setFlag(!flag)
  }

  useEffect(() => {
    api.get("/api/account/")
    .then(({data}) => {
      setAccounts(data)
    })
    .catch(error => console.error("API error: ", error))
  }, [flag])

  const handleValidateCases = () => {
    api.post("/api/case/validate")
    .then(({data}) => {
      alert("Validate cases job is finished.")
      refresh()
    })
    .catch(error => {
      console.error("API error: ", error)
      alert("Failed to trigger validate cases job: " + error?.response?.data?.error)
    })
  }

  if (accounts) {
  return (
  <>
    <div>
      <h1>Deepvin SuperAdmin Page !!!</h1>
      <h2> ALL Accounts</h2>
      <h5> Total {accounts.length} accounts</h5>
      <div>
        <AccountTable accounts={accounts} />
        {/* <ul>
        {accounts.map(account => 
          <li>
            <Link to={`/account/${account.ID}`}>{account.ID} - {account.Name}</Link>
          </li>
        )}
        </ul> */}
      </div>
      <button class="btn btn-outline-secondary me-3" onClick={()=>setShowAccountModal(true)}/*onClick={handleCreate}*/>Create Account</button>
       <button class="btn btn-outline-secondary me-3" onClick={handleValidateCases}>Validate Cases</button>
    </div>
    {<AccountAddModal show={showAccountModal} setShow={setShowAccountModal} refresh={refresh}/>}
  {/* <ReactJson src={{accounts}} /> */}
  </>
  )}
}

// export const Account = () => {  
//   return <TeamDataTree />
// }

export const AccountTable = ({accounts}) => {

  if (accounts)
  return (
    <table class="table table-hover">
    <thead>
      <th>ID</th>
      <th>Name</th>
      <th>Type</th> 
      <th>Users</th>
      <th>Devices</th>
      <th>Cases</th> 
      <th>Files</th>
      <th>Total Size (MB)</th>
      <th>Annual Call Volume</th>
      <th>Retention (days)</th>
      {/* <th>Monthly Fee</th> */}
      <th>Create Date</th>
      {/* <th>Last Updated</th> */}
      <th>Status</th>
    </thead>
    <tbody>
      {accounts.sort((a,b)=>a.ID-b.ID).map(account => <AccountTab account={account}/>)}
    </tbody>
  </table>
  )
}

export const AccountTab = ({account}) => {
    const { auth, setAuth } = useAuth()
    const api = useDeepVinApi()
    const [data, setData] = useState(account)
    const [disabled, setDisabled] = useState(account.Disabled)

    const handleChange = (field, val) => {     
      api.post(`/api/account/${account.UUID}/update`, {[field]: val})
      .then(({data}) => {
        setData(data)
        setDisabled(data.Disabled)
      })
      .catch(error => console.error("Error: ", error))
    }

    const onTypeSelect = (selectedValue) => handleChange("AccountType", selectedValue)

     
    if (account)
    return (
      <>
      <tr>
        <td>{account.ID}</td>
        <td><Link to={`/account/${account.UUID}/team`}>{account.Name}</Link></td>
        <td> {account.ID === 1 ? "--" 
          : <TypeSelector value={account.AccountType} options={accountTypes} onSelect={onTypeSelect} />}
        </td>
        <td>{account.ID === 1 ? "--" 
          : account.NumUsers}
        </td>
        <td>{account.ID === 1 ? "--" 
          : <Link to={`/account/${account.UUID}/device`}>{account.NumDevices}</Link>}
        </td> 
        <td>{account.ID === 1 ? "--" 
          : account.NumCases}
        </td> 
        <td>{account.ID === 1 ? "--" 
          : account.NumFiles}
        </td>
        <td>{account.ID === 1 ? "--" 
          : Math.round(account.TotalFileSize/1024/1024)}
        </td>
        <td>{account.ID === 1 ? "--" 
          : account.AnnualCallVolume}
        </td>
        <td>{account.ID === 1 ? "--" 
          : account.FileRetentionPeriod}
        </td>
        {/* <td>{account.ID === 1 ? "--" 
          : account.MonthlyFee}
        </td> */}
        <td>{TimeStringForTimeZone(auth, account.CreatedAt)}</td>
        {/* <td>{TimeStringForTimeZone(auth,account.UpdatedAt)}</td> */}
        <td> {account.ID === 1? "--" 
          : <button class="btn btn-sm btn-outline-secondary" onClick={() => handleChange("Disabled", !disabled)} /*disabled={account.Disabled}*/>{disabled ? "Enable" : "Disable"}</button>}
        </td>
      </tr>
      {/* <ReactJson src={{account}} /> */}
      </>
    )
}

const AccountAddModal = ({show, setShow, refresh}) => {
  const api = useDeepVinApi()
  const [accName, setAccName] = useState("")
  const [accSName, setAccSName] = useState("")
  const [accType, setAccType] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [trialPeriod, setTrialPeriod] = useState(30)

  const createAccount = (name, sname, type, email, fn, ln, tdays) => {
    api.post('/api/account/new', {
        Name: name,
        ShortName: sname,
        AccountType: type,
        Username: email,
        FirstName: fn,
        LastName: ln,
        TrialDays: Number.parseInt(tdays, 10),
      })
    .then(({data}) => refresh())
    .catch(error => console.error("Error creating new account: ", error))
  }

  const onHide = () => setShow(false)
  const handleSubmit = () => {
    createAccount(accName, accSName,accType, email, firstName,lastName, trialPeriod)
    setShow(false)
    //refresh()
  }

  return (
    <Modal show={show} onHide={onHide} centered={true}>
      <Modal.Header closeButton>
        <Modal.Title>Create new account and its root user</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-accnt">Account Name </span>
          <input type="text" class="form-control" placeholder="Account Name" aria-label="New account setup" aria-describedby="basic-addon2" value={accName} onChange={e=>setAccName(e.target.value)}/>
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text" id="accnt-sn">Account Short Name </span>
          <input type="text" class="form-control" placeholder="Short Name" aria-label="New account setup" aria-describedby="basic-addon2" value={accSName} onChange={e=>setAccSName(e.target.value)}/>
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text" id="accnt-type">Account Type </span>
          <TypeSelector value={accType} options={accountTypes} onSelect={setAccType}/>
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text" id="trial-days">Trial Days </span>
          <TypeSelector value={trialPeriod} options={trialDays} onSelect={setTrialPeriod}/>
        </div>
        <hr />
        <h5>Root user</h5>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-user">Username </span>
          <input type="text" class="form-control" placeholder="Email address" aria-label="New account setup" aria-describedby="basic-addon2" value={email} onChange={e=>setEmail(e.target.value)}/>
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-user">First Name</span>
          <input type="text" class="form-control" placeholder="First name" aria-label="New account setup" aria-describedby="basic-addon2" value={firstName} onChange={e=>setFirstName(e.target.value)}/>
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-user">Last Name</span>
          <input type="text" class="form-control" placeholder="Last name" aria-label="New account setup" aria-describedby="basic-addon2" value={lastName} onChange={e=>setLastName(e.target.value)}/>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSubmit}>Submit</Button>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}

export const GetAccountName = (aid, accounts) => {
  const acct = aid && accounts && accounts.find((a) => a.ID === aid)
  return acct ? acct.Name : ""
}
